<div [pSpacing]="{ 'margin-top': 'lg', 'margin-bottom': isJson ? 'none' : 'lg' }" [ngClass]="{ 'json-content': isJson }">
    <ng-lottie [options]="options" *ngIf="isJson"> </ng-lottie>
    <img [src]="visualSourcePath" *ngIf="!isJson" alt="" />
</div>
